import type { ReactNode } from 'react';

export const Page = ({ children }: { children: ReactNode }) => (
  <div className="page-root">{children}</div>
);

export const PageHeader = ({
  title,
  sub,
  actions,
  tabs,
}: {
  title: string;
  sub?: ReactNode;
  actions?: ReactNode;
  /** Sub-view switcher (see PageTabs), rendered under the title. */
  tabs?: ReactNode;
}) => (
  <div className="page-header">
    <div>
      <h2 className="page-title">{title}</h2>
      {sub && <p className="page-sub">{sub}</p>}
      {tabs}
    </div>
    {actions && <div className="page-header__actions">{actions}</div>}
  </div>
);
